module.exports = __webpack_public_path__ + "img/Medha.4944b1af.jpg";